import React from "react";

function FinancialTab({ data = {}, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className="bg-white p-3 rounded-md shadow-md border">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
        
        {/* Budget Allocated */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Budget Allocated</label>
          <input
            type="number"
            name="budget_allocated"
            value={data.budget_allocated || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Budget Allocated"
          />
        </div>

        {/* Actual Cost */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Actual Cost</label>
          <input
            type="number"
            name="actual_cost"
            value={data.actual_cost || ""}
            onChange={handleInput}
            disabled
            className="border rounded px-2 py-1 cursor-not-allowed"
            placeholder="Actual Cost"
          />
        </div>

        {/* Consultant Fees */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Consultant Fees</label>
          <input
            type="number"
            name="consultant_fees"
            value={data.consultant_fees || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Consultant Fees"
          />
        </div>

        {/* Revenue From Client */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Revenue From Client</label>
          <input
            type="number"
            name="revenue_from_client"
            value={data.revenue_from_client || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Revenue From Client"
          />
        </div>

        {/* Material Cost */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Material Cost</label>
          <input
            type="number"
            name="material_cost"
            value={data.material_cost || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Material Cost"
          />
        </div>

        {/* Labor Cost */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Labor Cost</label>
          <input
            type="number"
            name="labor_cost"
            value={data.labor_cost || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Labor Cost"
          />
        </div>

        {/* Travel Cost */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Travel Cost</label>
          <input
            type="number"
            name="travel_cost"
            value={data.travel_cost || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Travel Cost"
          />
        </div>
      </div>
    </div>
  );
}

export default FinancialTab;
